<template>
  <base-card
    style="font-size: 1.4em;"    
  >
        <v-list-item three-line
        @mouseover="hovering = true"
    @mouseleave="hovering = false"
    :style="{ color: isLink && hovering ? '#c41218' : '' }"
        >
            <v-list-item-content>                                
                
                <div v-if="secondaryvaluebig!='\xa0'" style="font-size: 1.4em;" :style="{ color: isLink && hovering ? '#c41218' : '' }" >
                    {{ [0, '0', '0%', null].includes(secondaryvaluebig) ? '-' : secondaryvaluebig }}
                </div>
                <div v-else class="body-2" :style="{ color: isLink && hovering ? '#c41218' : 'white' }">
                    {{secondaryvalue}}
                </div>                
                <v-list-item-title class="headline mb-1 font-weight-bold">
                  <span>{{ displayPrimary }}</span><span v-if="displayUnit">&nbsp;{{ displayUnit }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>
                    <div class="d-flex flex-wrap">
                        <span v-if="title" class="font-weight-bold text-info" :style="{ color: isLink && hovering ? '#c41218' : '' }"
                            >{{title}}</span
                        >
                        <span v-else class="font-weight-bold text-info"
                            >&nbsp;</span
                        >                                  
                    </div>
                </v-list-item-subtitle>
            </v-list-item-content>

            <!-- <apexchart
                width="100"
                height="120"
                type="radialBar"
                :options="getRatioWidgetData(stat.total_actual, stat.total_target).chartOptions"
                :series="getRatioWidgetData(stat.total_actual, stat.total_target).series"
            /> -->
        </v-list-item>
    </base-card>
</template>

<script>
import { formatCurrencyEUR, formatDecimal, formatInteger, formatPercent } from '@/core/number-utils.js'
export default {
  name: "CardDashboard",
  data() {
    return {
      hovering: false,
    }
  },
  props: {
    isLink: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '\xa0',
    },
    primaryvalue: {
      type: String | Number,
      default: '\xa0',
    },
    unit: {
      type: String,
      default: '\xa0',
    },

    secondaryvalue: {
      type: String | Number,
      default: '\xa0',
    },
    secondaryvaluebig: {
      type: String | Number,
      default: '\xa0',
    },
    valueformatting: {
      type: String,
      default: 'integer'
    }
  },
  methods: {
    shouldBeDash(src) {
      if ([0, '0', '0%', null, '-'].includes(src)) {
        return true;
      }
      return false;
    },
    formatPrimary(src) {
      if (this.shouldBeDash(src)) return '-';
      if (this.valueformatting === 'text') return src;
      if (this.isCurrency) return formatCurrencyEUR(src, 2);
      if (this.valueformatting === 'percent') return formatPercent(src);
      if (this.valueformatting === 'decimal') return formatDecimal(src, 2);
      if (this.valueformatting === 'decimalone') return formatDecimal(src, 1);
      return formatInteger(src);
    },
  },
  computed: {
    isCurrency() {
      return (this.unit || '').trim() === '€';
    },
    displayPrimary() {
      return this.formatPrimary(this.primaryvalue);
    },
    displayUnit() {
      if (this.shouldBeDash(this.primaryvalue)) return '';
      if (this.isCurrency) return '';
      const unitText = (this.unit || '').trim();
      if (!unitText) return '';
      return this.unit;
    },
  }
  // computed: {
  //   ...mapGetters(["getThemeMode"]),
  // },
};
</script>


<style lang="scss" scoped>
.v-card .v-list-item {
    // color: #304156 !important;
}
</style>
